import { ReportGmailerrorredOutlined as ReportGmailerrorredOutlinedIcon } from '@frontierag/frontier-ui-library/icons';
import { ROUTE_SEED_HOME, ROUTE_SEED_ORDERS_FAILED } from 'appConstants';

export const seedMenuItems = [
  {
    icon: <ReportGmailerrorredOutlinedIcon />,
    label: 'failedOrders',
    url: `${ROUTE_SEED_HOME}/${ROUTE_SEED_ORDERS_FAILED}`,
  },
];
